import type { FunctionComponent } from "react";
import LineItem from "components/job/LineItem";
import useListProps from "components/job/JobLayout/JobLineItems/List/useListProps";
export interface ListProps {}

const List: FunctionComponent<ListProps> = function () {
  const { lineItems } = useListProps();

  return (
    <>
      {lineItems &&
        lineItems.map((item) => (
          <div className="mb-2" key={`line-item-${item.title}`}>
            <LineItem lineItem={item} variant="job-summary" />
          </div>
        ))}
    </>
  );
};

export default List;
